module.exports = __webpack_public_path__ + "img/img_contact.f4bfbe8a.jpg";